/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from 'react'

import { notify } from '../../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import Menu from '../../../../components/Peyks/Menu'

import { useForm } from "react-hook-form"

import { post } from '../../../../services/http'

import { useNavigate } from 'react-router'

import peykIcon from '../../../../assets/svg/PMotorCycle.svg'

export default function index() {
  const navigate = useNavigate()

  const [clickButton, setClickButton] = useState(false)
  
  document.title = 'ساخت پیک'

  const { register, handleSubmit } = useForm()

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    console.log({
      name: data.name,
      meliCode: data.meliCode,
      phoneNumber: Number(data.phonenumber),
      birthday: data.birthday,
      education: data.education,
      motorCertificate: data.motorCertificate,
      motorInsurance: data.motorInsurance,
    })

    post('/api/front/peyks/create', {
      name: data.name,
      meliCode: data.meliCode,
      phoneNumber: Number(data.phonenumber),
      birthday: data.birthday,
      education: data.education,
      motorCertificate: data.motorCertificate,
      motorInsurance: data.motorInsurance,
    }, {
      'Content-Type': 'application/json'
    }).then(response => {
      if (response.data.messageFa === 'پیک جدید با موفقیت ساخته شد') {
        notify('success', 'ثبت نام با موفقیت انجام شد')
        setTimeout(() => {
          navigate('/peyk/peyks')
        }, 2000)
      }
    }).catch(error => {
      console.log()
      if (error.response.data.data.code === 11000) {
        notify('error', 'پیک قبلا ثبت نام کرده است')
      } else {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      }
    })
  }

  const categoryHandler = (e) => {
    // setCategorySelect(e.target.value)
    // setCategoryList([])
    // // eslint-disable-next-line array-callback-return
    // categories.map(item => {
    //   if (item.shop[0]._id === e.target.value) {
    //     setCategoryList(oldArray => [...oldArray, item])
    //   }
    // })
  }
  
  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'peyks'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={peykIcon} width={30} alt='resturantIcon' />
              </div>
              <div className='text'>
                 ایجاد پیک
              </div>
            </div>

            <div className="left">
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * تمامی اطلاعات رو پر کنید
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات پیک
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>نام و نام خانوادگی * :</label>
                <input id='foodName' {...register("name", { required: true, minLength: 3 })} type='text' placeholder='مثلا علی' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodPrice'>کدملی  * :</label>
                <input id='foodPrice' {...register("meliCode", { required: true, minLength: 3 })} className='ltrdirection' type='text' placeholder='25...' />
                <small id='foodPriceAlert'>کدملی باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodLevele'>شماره موبایل * :</label>
                <input id='foodLeveleDetails' {...register("phonenumber", { required: true })} className='ltrdirection' type='number' />
                <small id='foodLeveleDetailsAlert'>شماره موبایل باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodDiscountPrice'>تاریخ تولد * :</label>
                <input id='foodDiscountPrice' {...register("birthday", { required: true })} className='ltrdirection' type='text' placeholder='13...' />
                <small id='foodDiscountPriceAlert'>تاریخ تولد با تحفیف باید وارد شود</small>
              </div>
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='resturantName'>تحصیلات * : </label>
                <select id='resturantName' {...register("education", { 
                  onChange: (e) => {categoryHandler(e)},
                  required: true })}>
                  <option id='none'>انتخاب کنید</option>
                  <option value={'سیکل'}>سیکل</option>
                  <option value={'دیپلم'}>دیپلم</option>
                  <option value={'کاردانی'}>کاردانی</option>
                  <option value={'کارشناسی'}>کارشناسی</option>
                  <option value={'کارشناسی ارشد'}>کارشناسی ارشد</option>
                </select>
                <small id='resturantNameAlert'>رستوران باید انتخاب شود</small>
              </div>
              <div className='column'>
                <label htmlFor='categoryName'>گواهینامه * : </label>
                <select id='categoryName' {...register("motorCertificate", { required: true })}>
                  <option id='none'>انتخاب کنید</option>
                  <option value={true}>بله</option>
                  <option value={false}>خیر</option>
                </select>
                <small id='categoryNameAlert'>رستوران باید انتخاب شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='categoryName'>بیمه موتور * : </label>
                <select id='categoryName' {...register("motorInsurance", { required: true })}>
                  <option id='none'>انتخاب کنید</option>
                  <option value={true}>بله</option>
                  <option value={false}>خیر</option>
                </select>
                <small id='categoryNameAlert'>رستوران باید انتخاب شود</small>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'آپدیت پیک'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
